import React, { useEffect, useState } from "react";
import { Stepper } from "./Stepper";
import {
  Content,
  FormContainer,
  PreQualifyRoot,
  StyledMobileTempText,
  StyledPylonTemp,
  StyledTempMobileContainer,
} from "./styles";
import { useMediaQuery } from "react-responsive";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import updateObjectByPath from "../../common/updateObjectByPath";
import { useDispatch, useSelector } from "react-redux";
import {
  esubInfoSelector,
  qualificationSelector,
  esubSelectedInfoSelector,
} from "../../data/selectors/user";
import {
  checkAuth,
  eSubUser,
  getEsubInfo,
  getPreQualificationInfo,
  getSelectedCCDCInfo,
  getSelectedEsubInfo,
  preQualifyUser,
  clearEsubData,
} from "../../data/actions/user";
import { contactSelector } from "../../data/selectors/contact";
import { getContact } from "../../data/actions/contact";

//logos
import { OwnerPartners } from "./components/OwnerPartners";
import { FinancialForm } from "./components/FinancialForm";
import { AdditionalDocuments } from "./components/additionalDocuments/additionalDocuments";
import { PrincipalProjectsForm } from "./components/principalProjectsForm";
import { AnnualRecords } from "./components/AnnualRecords";
import { PersonnelSelection } from "./components/personnelSelection";
import { FillValueConstruction } from "./components/valueOfConstruction/fillValueConstruction";
import { ReviewForm } from "./components/reviewForm";
import PylonIcon from "assets/common/pylonIcon.png";
import { getInsuranceTypes, getSelectedEsubInfo as getSelectedEsubInfoFromAPI } from "api/external_data";
import { getInstitutionProfileInfo } from "data/actions/serviceProvider";
import { setECQSWizardContext } from "../../data/actions/ecqs";
import { getECQSWizardContextSelector } from "../../data/selectors/ecqs";
import { InviteUnderwriters } from "./components/inviteUnderwriters";
import { BondDetails } from "./components/bondDetails";
import { TemplateSelection } from "./components/TemplateSelection";
import BondSubBreadcrumb from "./components/BondSubBreadcrumb";
import { useRadioGroup } from "@material-ui/core";

function NewPreQualify() {
  const isMobile = useMediaQuery({ maxWidth: 960 });

  let history = useHistory();
  const dispatch = useDispatch();
  const qualification = useSelector(qualificationSelector);
  const esub = useSelector(esubInfoSelector);

  const wizardContext = useSelector(getECQSWizardContextSelector, null);

  const [prequalifyData, setPrequalifyData] = useState({});

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const section = location.state?.section || "";
  // Explicitly check for "ecqs" section to ensure CQS mode
  const isESub = section === "ecqs" 
    ? false 
    : (wizardContext === "e-sub" || params.get("e-sub") === "true" || section === "esub");  

  const ccdcId = location.state?.ccdcId || "";
  const [institutionId, setInstitutionId] = useState(
    location.state?.institution_id || "",
  );

  console.log("location.state: ", location.state);

  const [userId] = useState(location.state?.userId || "");

  const currentDashboardUrl = localStorage.getItem("current_dashboard_url");
  const [action, setAction] = useState(location.state?.action || "new");
  const [esubId, setEsubId] = useState(location.state?.esubId || null);
  const [step, setStep] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [fileType, setFileType] = useState("");
  const [pdfFileSequence, setPdfFileSequence] = useState([]);
  const [insuranceType, setInsuranceType] = useState([]);
  const [currNavLocation, setCurrNavLocation] = useState({ step: 0, panel: 0 });
  const [navigationSequence, setNavigationSequence] = useState(
    isESub
      ? {
        0: {
          path: ["/qualifying"],
          visited: true,
          name: "Project Selection",
        },
        1: {
          path: ["/info/owner"],
          visited: false,
          name: "Owner Info",
        },
        2: {
          path: [
            "/bond/principal",
            "/bond/obligee",
            "/bond/bid",
            "/bond/penality",
            "/bond/bond",
            "/bond/job-cost-breakdown",
            "/bond/subcontractor",
            "/bond/remarks",
          ],
          visited: false,
          name: "Bond Info",
        },
        3: {
          path: [
            "/financial/bank",
            "/financial/bond",
            "/financial/insurance",
            // "/financial/general",
            // "/financial/automobile",
            // "/financial/equipment",
          ],
          visited: false,
          name: "Financial Institutions",
        },
        4: { path: ["/safety"], visited: false, name: "Health & Safety" },
        5: { path: ["/value"], visited: false, name: "Financial Records" },
        6: { path: ["/projects"], visited: false, name: "Showcase Projects" },
        7: { path: ["/personnels"], visited: false, name: "Personnel" },
        8: {
          path: ["/additional/documents"],
          visited: false,
          name: "Additional Documents",
        },
        9: {
          path: ["/preview/ecqs", "/preview/format", "/preview/download"],
          visited: false,
          name: "Review and Download",
        },
        10: {
          path: ["/invite-underwriters"],
          visited: false,
          name: "Share Online",
        },
      }
      : {
        0: {
          path: ["/qualifying"],
          visited: true,
          name: "Project Selection",
        },
        1: {
          path: ["/info/owner"],
          visited: false,
          name: "Owner Info",
        },
        2: {
          path: [
            "/financial/bank",
            "/financial/bond",
            "/financial/insurance",
            // "/financial/general",
            // "/financial/automobile",
            // "/financial/equipment",
          ],
          visited: false,
          name: "Financial Institutions",
        },
        3: { path: ["/safety"], visited: false, name: "Health & Safety" },
        4: { path: ["/value"], visited: false, name: "Financial Records" },
        5: { path: ["/projects"], visited: false, name: "Showcase Projects" },
        6: { path: ["/personnels"], visited: false, name: "Personnel" },
        7: {
          path: ["/additional/documents"],
          visited: false,
          name: "Additional Documents",
        },
        8: {
          path: ["/preview/ecqs", "/preview/format", "/preview/download"],
          visited: false,
          name: "Review and Download",
        },
        9: {
          path: ["/invite-underwriters"],
          visited: false,
          name: "Share Online",
        },
      },
  );

  const esubSelectedInfo = useSelector(esubSelectedInfoSelector);
  const contact = useSelector(contactSelector);

  useEffect(() => {
    // Setting ecqs/esub wizard context
    if (isESub) {
      dispatch(setECQSWizardContext("e-sub"));
    } else {
      dispatch(setECQSWizardContext("e-cqs"));
    }
  }, [dispatch]);


  useEffect(() => {
    if (isESub && action === "new") {
      dispatch(clearEsubData());
    }
  }, [dispatch, isESub, action]);

  useEffect(() => {
    // Use institutionId from state or fall back to contact
    const effectiveInstitutionId = institutionId || contact?.user_access_control?.institution_id;
    
    if (action === "edit") {
      if (isESub) {
        // dispatch(getSelectedEsubInfo(esubId, action, { institution_id: effectiveInstitutionId }));
      } else {
        dispatch(
          getSelectedCCDCInfo(ccdcId, action, { institution_id: effectiveInstitutionId }),
        );
      }
    } else {
      if (
        isESub &&
        (location.pathname === "/prequalify/qualifying")
      ) {
        console.log("step 0", step)
        dispatch(clearEsubData());
        dispatch(getEsubInfo({ institution_id: institutionId, user_id: userId, account_id: accountId }));
      } else {
        console.log("ee", esub)
        dispatch(getPreQualificationInfo({ institution_id: effectiveInstitutionId }));
      }
    }
  }, [dispatch, action, isESub, esubId, ccdcId, institutionId, contact]);

  useEffect(() => {
    console.log("esub updated 2: ", esub)
    const currentStepName = getCurrentStepName();
    if (false) { /* Removed isProcessingApiResponse logic */
      console.log("isProcessingApiResponse")
      return;
    }
    
    if (action === "edit") {
      console.log("Entering edit ", esub)
      
      if (isESub && esub && Object.keys(esub).length > 0) {
        console.log("Updating prequalifyData to esubSelectedInfo: ", esubSelectedInfo)
        setPrequalifyData(prev => ({
        ...prev,
        ...esub,
        project_info: {
          ...prev.project_info,
          ...(esub.project_info || {}),
        },
      }));
        return; 
      } else if (esub && Object.keys(esub).length > 0 && esub.esubId) {
        console.log("Updating prequalifyData to esubSelectedInfo: ", esubSelectedInfo)
        if (prequalifyData?.esubId === esub?.esubId && Object.keys(prequalifyData).length >= Object.keys(esub).length) {
        console.log("return 2: ", esubSelectedInfo)
          return;
        }
        setPrequalifyData(prev => ({
        ...prev,
        ...esub,
        project_info: {
          ...prev.project_info,
          ...(esub.project_info || {}),
        },
      }));
        return; 
      } else if (!isESub && qualification && Object.keys(qualification).length > 0) {
        console.log("return 3: ", qualification)
        setPrequalifyData({ ...qualification });
        return; 
      } else {
        console.log("No condition met")
      }
    }
    
    if (action === "new") {
      console.log("Entering new")
      if (prequalifyData?.esubId) {
        return;
      }
      
      if (esub?.esubId || esubSelectedInfo?.esubId) {
        console.log("return 4: ", esub?.esubId || esubSelectedInfo?.esubId)
        const existingEsubId = esub?.esubId || esubSelectedInfo?.esubId;
        return;
      }
      
      if (isESub && esub && Object.keys(esub).length > 0) {
        console.log("Updating prequalifyData to esub: ", esub)
          setPrequalifyData(prev => ({
              ...prev,
              ...esub,
              project_info: {
               ...prev.project_info,           
                ...(esub.project_info || {}),   
              },
            }));
        return;  
      } else if (esub && Object.keys(esub).length > 0 && esub.esubId) {
        console.log("return 5: ", esub)
        const hasUserEnteredData = prequalifyData?.project_info?.obligee_info?.obligee_name || 
                                   prequalifyData?.project_info?.principal_info?.principal_name ||
                                   Object.keys(prequalifyData).length > 5;
        
        if (hasUserEnteredData) {
          return;
        }

        setPrequalifyData({ ...esub });
        return; 
      } else if (!isESub && qualification && Object.keys(qualification).length > 0) {
        console.log("return 6: ", qualification)
        setPrequalifyData({ ...qualification });
        return; 
      }
    }
    
    if (!isESub && qualification && Object.keys(qualification).length > 0 && Object.keys(prequalifyData).length <= 1) {
      console.log("return 7: ", qualification)
      setPrequalifyData({ ...qualification });
    }
    
  }, [esub]);

  useEffect(() => {
    getInsuranceTypes()
      .then((res) => {
        setInsuranceType(res);
      })
      .catch(() => {
        // TODO: HANDLE ERROR OPERLY
      });
    if (section === "ecqs") {
      let newCurrLocation = {};
      // Use step 9 for eSub (which has Bond Details), step 8 for standard CQS
      newCurrLocation = { step: isESub ? 9 : 8, panel: 0 };

      let visitedSequence = { ...navigationSequence };

      visitedSequence[newCurrLocation.step].visited = true;

      setNavigationSequence(visitedSequence);
      const newPath =
        navigationSequence?.[newCurrLocation.step]?.path?.[
        newCurrLocation.panel
        ];
      history.push("/prequalify" + newPath);
      setCurrNavLocation(newCurrLocation);
    }

    if (section === "esub") {
      let newCurrLocation = {};
      newCurrLocation = { step: 9, panel: 0 };

      let visitedSequence = { ...navigationSequence };

      visitedSequence[newCurrLocation.step].visited = true;

      setNavigationSequence(visitedSequence);
      const newPath =
        navigationSequence?.[newCurrLocation.step]?.path?.[
        newCurrLocation.panel
        ];
      history.push("/prequalify" + newPath);
      setCurrNavLocation(newCurrLocation);
    }

    if (
      currentDashboardUrl === "/service-provider-dashboard" &&
      institutionId
    ) {
      dispatch(
        getInstitutionProfileInfo(
          { institution_id: institutionId },
          () => { },
          () => { },
        ),
      );
    }
  }, []);

  const [accountId, setAccountId] = useState(location.state?.accountId ?? "");
  // Removed isProcessingApiResponse state

  useEffect(() => {
    if (accountId && action === "new" && isESub) {
      setPrequalifyData({});
    }
  }, [accountId, action, isESub]);

  useEffect(() => {
    if (isESub && action === "edit-esub") {
      getSelectedEsubInfoFromAPI(esubId, "edit", {
        account_id: accountId,
        user_id: userId,
        institution_id: institutionId
      }, (response) => {
        setPrequalifyData(response);
      }, () => {

      });
    }
  }, [isESub, action]);

  const onChangeData = (attribute, val) => {
    const currentStepName = getCurrentStepName();
    setPrequalifyData((prevState) => {
      const updatedData = JSON.parse(JSON.stringify(prevState));
      updateObjectByPath(updatedData, attribute, val);
      return updatedData;
    });
  };

  // Helper function to get current step name
  const getCurrentStepName = () => {
    const path = window.location.pathname;
    if (path.includes('/qualifying')) return 'Template Selection';
    if (path.includes('/bond')) return 'Bond Details';
    if (path.includes('/info')) return 'Owner Info';
    if (path.includes('/financial')) return 'Financial Institutions';
    if (path.includes('/safety')) return 'Health & Safety';
    if (path.includes('/value')) return 'Financial Records';
    if (path.includes('/projects')) return 'Showcase Projects';
    if (path.includes('/personnels')) return 'Personnel';
    if (path.includes('/additional')) return 'Additional Documents';
    if (path.includes('/preview')) return 'Review and Download';
    if (path.includes('/invite-underwriters')) return 'Share Online';
    return 'Unknown Step';
  };

  const iconList = [];

  const stepLabels = [
    "Step 1",
    "Step 2",
    "Step 3",
    "Step 4",
    "Step 5",
    "Step 6",
    "Step 7",
    "Step 8",
    "Step 9",
  ];

  const [list, setList] = useState([iconList[0]]);
  const [labels, setLabels] = useState([stepLabels[0]]);
  const [panel, setPanel] = useState(1);
  const [isBranchPanel, setIsBranchPanel] = useState(false);
  const [isLastPanel, setIsLastPanel] = useState(false);
  const [previousStepPanel, setPreviousStepPanel] = useState("");
  const [disabledSelect, setDisabledSelect] = useState(true);
  const [popupSkip, setPopupSkip] = useState(false);
  const [rfpq, setRfpq] = useState("");

  const handleCCDCGenerate = (projectData = null) => {
    const currentStepName = getCurrentStepName();
    let formData = new FormData();

    const finalInstitutionId = institutionId || "";
    let cacheDataCopy = { institution_id: finalInstitutionId, account_id: accountId, user_id: userId, ...prequalifyData };

    if (projectData && typeof projectData === "object") {
      if (projectData.project_info) {
        cacheDataCopy.project_info = {
          ...cacheDataCopy.project_info,
          ...projectData.project_info,
        };
      } else {
        cacheDataCopy.project_info = {
          ...cacheDataCopy.project_info,
          ...projectData,
        };
      }
    }

    if (projectData && typeof projectData === "object") {
      Object.keys(projectData).forEach((key) => {
        if (key !== "project_info") {
          if (typeof projectData[key] === "object" && projectData[key] !== null) {
            cacheDataCopy[key] = {
              ...cacheDataCopy[key],
              ...projectData[key],
            };
          } else {
            cacheDataCopy[key] = projectData[key];
          }
        }
      });
    }

    // Ensure properties aren't overwritten
    if (cacheDataCopy.institution_id !== finalInstitutionId) {
      cacheDataCopy.institution_id = finalInstitutionId;
    }

    if (cacheDataCopy.account_id !== accountId) {
      cacheDataCopy.account_id = accountId;
    }

    if (cacheDataCopy.user_id !== userId) {
      cacheDataCopy.user_id = userId;
    }

    cacheDataCopy.esubId = esubId;

    let data = cacheDataCopy?.additional_document;
    let arrayKey = `additionalFiles`;
    try {
      if (data) {
        arrayKey = `additionalFiles`;

        data.forEach((v) => {
          if (!(v instanceof File)) {
            v = new File([v.file.split("base64,")[1]], v.name, {
              type: v.content_type,
            });
          }
          formData.append(arrayKey, v);
        });
      }
    } catch { }

    // add legal structure personnel resumes
    data = cacheDataCopy?.legal_structure?.personnel;

    try {
      if (data) {
        arrayKey = `personnel`;

        data.forEach((v, i) => {
          if (v.resume) {
            if (v.id) {
              formData.append(`${arrayKey}[${v.id}]`, v.resume);
            } else {
              formData.append(`${arrayKey}-new-[${i}]`, v.resume);
            }
          }

          // try {
          //   delete cacheDataCopy["legal_structure"]["personnel"][i]["resume"];
          // } catch {}
        });
      }
    } catch { }

    // add personnel resumes
    data = cacheDataCopy?.key_personnel;
    try {
      if (data) {
        arrayKey = `key_personnel`;

        data.forEach((v, i) => {
          if (v.resume) {
            if (v.id) {
              formData.append(`${arrayKey}[${v.id}]`, v.resume);
            } else {
              formData.append(`${arrayKey}-new-[${i}]`, v.resume);
            }
          }
          // try {
          //   delete cacheDataCopy["key_personnel"][i]["resume"];
          // } catch {}
        });
      }
    } catch { }

    // add CORS file
    if (cacheDataCopy?.years?.CORfileOrEquivalent) {
      formData.append(
        "CORfileOrEquivalent",
        cacheDataCopy?.years?.CORfileOrEquivalent,
      );
    }

    try {
      delete cacheDataCopy["additional_document"];
    } catch { }
    try {
      delete cacheDataCopy["years"]["CORfileOrEquivalent"];
    } catch { }
    
    formData.append("data", JSON.stringify(cacheDataCopy));

    for (let [key, value] of formData.entries()) {
      if (key === "data") {
        const parsedData = JSON.parse(value);
      }
    }

    return formData;
  };

  // Account ID: location.state?.accountId
  const handleNext = (handleGenericGenerate, getPDF, projectData = null) => {
    const currentStepName = getCurrentStepName();

    if (isESub && action === "edit" && esubSelectedInfo && Object.keys(esubSelectedInfo).length > 0) {
      if (!prequalifyData.esubId || Object.keys(prequalifyData).length < Object.keys(esubSelectedInfo).length) {
        if (!prequalifyData.esubId) {
          console.log("Step 3", prequalifyData);
          setPrequalifyData(prev => ({
        ...prev,
        ...esubSelectedInfo,
        project_info: {
          ...prev.project_info,
          ...(esubSelectedInfo.project_info || {}),
        },
      }));
          setTimeout(() => {
            proceedWithApiCall(handleGenericGenerate, getPDF, projectData);
          }, 100);
          return;
        } 
      }
    }

    proceedWithApiCall(handleGenericGenerate, getPDF, projectData);
  };

  const proceedWithApiCall = (handleGenericGenerate, getPDF, projectData) => {
    const currentStepName = getCurrentStepName();
    // Proceed With API Call logged
  
    const currentInstitutionId = institutionId;
    
    if (!currentInstitutionId) {
      alert("Error: Institution ID is required. Please refresh the page and try again.");
      return;
    }
    
    dispatch(
      checkAuth(
        () => { },
        () => {
          history.push("/account/login");
        },
      ),
    );

    let data = handleCCDCGenerate(projectData);

    if (data instanceof FormData) {
      for (let [key, value] of data.entries()) {
        // FormData entry logged
      }
    }

    if (handleGenericGenerate || getPDF) {
      // Determine which API to hit based on wizard context
      const apiDispatcher = wizardContext === "e-sub" ? eSubUser : preQualifyUser; 

      if (fileType === "generic") {
        if (typeof handleGenericGenerate === "function") {
          handleGenericGenerate(prequalifyData);
        }
        dispatch(
          apiDispatcher(data, action, (res) => {
            // handleGenericGenerate(res);
          }),
        );
      } else {
        if (typeof getPDF === "function") {
          getPDF(prequalifyData);
        }
        dispatch(
          apiDispatcher(data, action, (res) => {
            // getPDF(res);
          }),
        );
      }
    } else {
      if (wizardContext === "e-sub") {
        for (let [key, value] of data.entries()) {
          if (key === "data") {
            const parsedData = JSON.parse(value);
          }
        }
        
        dispatch(
          eSubUser(
            data,
            action,
            (res) => {
              console.log("Called eSubUser", typeof data === "string" ? data.slice(0, 50) : (data instanceof FormData ? (data.get("data") ? String(data.get("data")).slice(0, 50) : "[FormData]") : "[Unknown data type]"));
              // removed setIsProcessingApiResponse(true);
              if (res && res.esubId) {
                if (action === "new") {
                  setEsubId(res.esubId);
                  
                   setTimeout(() => {
                    if (action === "new") {
                      setAction("edit");
                    }
                  }, 50);
                }
              }
            },
            () => { },
          ),
        );
      } else {
        // E-CQS payload logged
        dispatch(
          preQualifyUser(
            data,
            action,
            (res) => {
              // E-CQS API Response logged
              if (res && res.ccdcId && action === "new") {
                // Setting ccdcId from response
                onChangeData("ccdcId", res.ccdcId);
              }
            },
            () => { },
          ),
        );
      }
    }

    // Action change is now handled in the API response callback for e-sub
    // For e-cqs, still change action immediately since they don't have the same timing issues
    if (action === "new") {
      setAction("edit");
    }

    let newCurrLocation = {};

    if (
      currNavLocation.panel <
      navigationSequence?.[currNavLocation.step]?.path?.length - 1
    ) {
      // Called
      newCurrLocation = {
        ...currNavLocation,
        panel: currNavLocation.panel + 1,
      };
    } else {
      newCurrLocation = { step: currNavLocation.step + 1, panel: 0 };
      let visitedSequence = { ...navigationSequence };
      visitedSequence[newCurrLocation.step].visited = true;
      setNavigationSequence(visitedSequence);
    }

    const newPath =
      navigationSequence?.[newCurrLocation.step]?.path?.[newCurrLocation.panel];
    history.push("/prequalify" + newPath);

    setCurrNavLocation(newCurrLocation);
  };

  const handleShareOnline = () => {
    const newCurrLocation = { step: 10, panel: 0 };
    let visitedSequence = { ...navigationSequence };
    visitedSequence[newCurrLocation.step].visited = true;
    setNavigationSequence(visitedSequence);

    const newPath =
      navigationSequence?.[newCurrLocation.step]?.path?.[newCurrLocation.panel];
    history.push("/prequalify" + newPath);

    setCurrNavLocation(newCurrLocation);
  };

  return (
    <>
      {!isMobile && (
        <PreQualifyRoot>
          <Stepper
            step={step}
            setStep={setStep}
            iconList={iconList}
            list={list}
            setList={setList}
            setLabels={setLabels}
            panel={panel}
            setPanel={setPanel}
            isLastPanel={isLastPanel}
            setIsLastPanel={setIsLastPanel}
            isBranchPanel={isBranchPanel}
            setIsBranchPanel={setIsBranchPanel}
            previousStepPanel={previousStepPanel}
            onboardingData={prequalifyData}
            setOnboardingData={onChangeData}
            setAction={setAction}
            setNavigationSequence={setNavigationSequence}
            navigationSequence={navigationSequence}
            currNavLocation={currNavLocation}
            setCurrNavLocation={setCurrNavLocation}
            history={history}
          />
          {isESub && location.pathname.startsWith("/prequalify/bond") && (
            <BondSubBreadcrumb />
          )}
          <FormContainer isMobile={isMobile}>
            <Content>
              <Switch>
                <Route exact path="/prequalify/qualifying">
                  <TemplateSelection
                    step={0}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    setDownloading={setDownloading}
                    setPopupSkip={setPopupSkip}
                    setIsBranchPanel={setIsBranchPanel}
                    rfpq={rfpq}
                    setRfpq={setRfpq}
                    institutionId={institutionId}
                  />
                </Route>
                {wizardContext === "e-sub" && (
                  <Route path="/prequalify/bond">
                    <BondDetails
                      step={1}
                      esubData={prequalifyData}
                      setEsubData={onChangeData}
                      handleNext={handleNext}
                      panel={panel}
                      setPanel={setPanel}
                      setIsLastPanel={setIsLastPanel}
                      setPreviousStepPanel={setPreviousStepPanel}
                      accountId={accountId}
                    />
                  </Route>
                )}
                <Route path="/prequalify/info">
                  <OwnerPartners
                    step={wizardContext === "e-sub" ? 2 : 1}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    popupSkip={popupSkip}
                    setIsBranchPanel={setIsBranchPanel}
                  />
                </Route>
                <Route path="/prequalify/financial">
                  <FinancialForm
                    step={wizardContext === "e-sub" ? 3 : 2}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    setIsBranchPanel={setIsBranchPanel}
                    insuranceTypeList={insuranceType}
                    institutionId={institutionId}
                    esubId={esubId}
                  />
                </Route>
                <Route exact path="/prequalify/safety">
                  <AnnualRecords
                    step={wizardContext === "e-sub" ? 4 : 3}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    institutionId={institutionId}
                  />
                </Route>
                <Route exact path="/prequalify/value">
                  <FillValueConstruction
                    step={wizardContext === "e-sub" ? 5 : 4}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    institutionId={institutionId}
                  />
                </Route>

                <Route exact path="/prequalify/projects">
                  <PrincipalProjectsForm
                    step={wizardContext === "e-sub" ? 6 : 5}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    institutionId={institutionId}
                  />
                </Route>
                <Route exact path="/prequalify/personnels">
                  <PersonnelSelection
                    step={wizardContext === "e-sub" ? 7 : 6}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    institutionId={institutionId}
                  />
                </Route>
                <Route path="/prequalify/additional">
                  <AdditionalDocuments
                    step={wizardContext === "e-sub" ? 8 : 7}
                    handleNext={handleNext}
                    panel={panel}
                    setPanel={setPanel}
                    setIsLastPanel={setIsLastPanel}
                    setPreviousStepPanel={setPreviousStepPanel}
                    prequalifyData={prequalifyData}
                    setPrequalifyData={onChangeData}
                    action={action}
                    setAction={setAction}
                    fileType={fileType}
                    setFileType={setFileType}
                    updateCachedData={setPrequalifyData}
                    setPdfFileSequence={setPdfFileSequence}
                    rfpq={rfpq}
                    institutionId={institutionId}
                  />
                </Route>
                <Route path="/prequalify/preview">
                  <ReviewForm
                    step={wizardContext === "e-sub" ? 9 : 8}
                    setIsLastPanel={setIsLastPanel}
                    handleNext={handleNext}
                    setPreviousStepPanel={setPreviousStepPanel}
                    pdfFileSequence={pdfFileSequence}
                    setPrequalifyData={onChangeData}
                    prequalifyData={prequalifyData}
                    ccdcId={ccdcId}
                    action={action}
                    setAction={setAction}
                    setFileType={setFileType}
                    updateCachedData={setPrequalifyData}
                    setPdfFileSequence={setPdfFileSequence}
                    fileType={fileType}
                    insuranceTypeList={insuranceType}
                    institutionId={institutionId}
                    handleShareOnline={handleShareOnline}
                  />
                </Route>
                {isESub && (
                  <Route path={"/prequalify/invite-underwriters"}>
                    <InviteUnderwriters esubData={prequalifyData} />
                  </Route>
                )}
              </Switch>
            </Content>
          </FormContainer>
        </PreQualifyRoot>
      )}
      {isMobile && (
        <StyledTempMobileContainer>
          <StyledPylonTemp src={PylonIcon} />
          <StyledMobileTempText>
            Please switch to <br />
            desktop for best experience
          </StyledMobileTempText>
        </StyledTempMobileContainer>
      )}
    </>
  );
}

export default NewPreQualify;
